import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';

@Component({
    selector: 'ui-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  @Input() isOpen: boolean = false;
  @Input() isDismissable: boolean = true;
  @Output() onDismiss = new EventEmitter();
  @ViewChild(IonModal) modal: IonModal;

  closeModal() {
    this.modal.dismiss();
    this.onDismiss.emit();
  }
}
